import React from 'react';

import GoalsSidebarItem from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goals-sidebar/goals-sidebar-item/goals-sidebar-item';
import type { Goal } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

export interface GoalSelectArg {
  event: React.MouseEvent<HTMLButtonElement> | null;
  to: string;
  id: string | number;
}

interface GoalsSidebarProps {
  goals?: Goal[];
  handleGoalSelect: (arg: GoalSelectArg) => void;
  selectedGoal: string | number;
  isNew: boolean;
  isEditMode: boolean;
}

const GoalsSidebar = ({
  goals = [],
  handleGoalSelect,
  selectedGoal,
  isNew,
  isEditMode,
}: GoalsSidebarProps): React.JSX.Element => (
  <div className="w-[300px] min-w-0 shrink-0 pr-4 pt-4 border-r overflow-hidden">
    {isNew && <GoalsSidebarItem isNew={isNew} />}
    {goals.map((goal) => (
      <GoalsSidebarItem
        key={goal?.id}
        goal={goal}
        handleGoalSelect={handleGoalSelect}
        selectedGoal={selectedGoal}
        disabled={isNew || isEditMode}
      />
    ))}
  </div>
);

export default GoalsSidebar;
